import $ from 'jquery';

class Animations {
    constructor() {
        this.elements = document.querySelectorAll('.js-anim');
        this.observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (window.Launchpad.pageBuilderEditMode) {
                    entry.target.style.transition = 'none';
                    entry.target.classList.add('shows');
                    entry.target.classList.remove('no-visible');
                } else if (entry.isIntersecting) {
                    entry.target.classList.add('shows');
                    entry.target.classList.remove('js-anim');
                    entry.target.classList.remove('no-visible');
                    observer.unobserve(entry.target);
                }
            });
        });
    }

    init() {
        this.elements.forEach((e, i) => {
            this.observer.observe(e);
        });
    }
}

export default Animations;

$(() => {
    new Animations().init();
});